export default __webpack_public_path__ + "static/media/Trussville-video.9ca2eea2.mp4";